export const getPpnSlug = () =>
  process.env.REACT_APP_ENVIRONMENT_SLUG === 'production' ? 'ppn' : 'ppnlite';
